<template>
    <Wait_Skeleton v-if="!IsWait" />
    <div class="formgrid grid " v-if="IsWait">
        <div class="col-12">
            <div class="col-6">
                <div class="grid">
                    <div class="col-6">
                        <label for="Isim" class="font-bold block">İsim</label>
                        <InputText id="Isim" type="text" v-model="Isim" class="text-base text-color w-full"
                            :invalid="this.Valid.Isim" disabled />
                    </div>
                    <div class="col-6">
                        <label for="Grup" class="font-bold block">Grup</label>
                        <Select id="Grup" v-model="pGrup" :options="GrupListesi" optionLabel="Ad"
                            optionValue="Grup_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                            :invalid="this.Valid.pGrup" class="text-base text-color w-full" />
                    </div>
                    <div class="col-12">
                        <label for="Aciklama" class="font-bold block">Açıklama</label>
                        <Textarea id="Aciklama" v-model="Aciklama" rows="2" cols="30" :invalid="this.Valid.Aciklama"
                            class="text-base text-color w-full" />
                    </div>
                </div>
            </div>
            <div class="col-6">
                <!-- sağ bölüm -->
            </div>
        </div>
    </div>
    <div class="col-12">
        <IslemYapiliyor v-if="IslemYapiliyor" />
    </div>
    <div class="col-12 flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
            @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor" />
    </div>
</template>

<script>
import GlobalServis from "../../../../../../services/GlobalServis";
export default {
    props: {
        pMusteri: Number
    },
    data() {
        return {
            IslemYapiliyor: false,
            IsWait: false,
            Musteri_rowid: 0,
            //
            GrupListesi: [],

            Isim: "",
            pGrup: 0,
            Aciklama: "",

            //--------------
            // Validation Elements
            Valid: {
                Isim: false,
                pGrup: false,
                Aciklama: false,

            }
        };
    },
    methods: {
        handleClick() {
            if (this._FormCheck()) { return; }
            this.IslemYapiliyor = true;

            let data = {
                Musteri_rowid: this.Musteri_rowid,
                Isim: this.Isim,
                pGrup: this.pGrup,
                Aciklama: this.Aciklama,

            };

            GlobalServis.GlobalServis("POST", "UpdateMusteri", data).then((res) => {
                if (res.status == 200) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Başarılı",
                        detail: "Musteri düzenlenmiştir.",
                        life: 3000,
                    });
                    this._ResetForm();
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
                this.IslemYapiliyor = false;
                this.$router.push({ path: "/Musteri/MusteriListesi" });
            });
        },
        _MusteriInfo() {
            this.Musteri_rowid = this.pMusteri;
            let data = {
                Musteri_rowid: this.pMusteri,
            };
            GlobalServis.GlobalServis("POST", "GetMusteriInfo", data).then((res) => {
                if (res.status == 200) {
                    this.Isim = res.data[0].Isim;
                    this.pGrup = res.data[0].pGrup;
                    this.Aciklama = res.data[0].Aciklama;

                    this.IsWait = true;

                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });

        },
        _GrupListesi() {
            GlobalServis.GlobalServis("GET", "GetGrup_Musteri", "").then((res) => {
                if (res.status == 200) {
                    this.GrupListesi = res.data;
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        },
    },
    _ResetForm() {
        this.Isim = "";
        this.pGrup = 0;
        this.Aciklama = "";
    },
    _FormCheck() {
        let Check = false;
        if (this.Isim === "") {
            this.Valid.Isim = true;
            this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Ünvan girin", life: 3000, });
            Check = true;
            return Check;
        } else { this.Valid.Isim = false; Check = false; }

        return Check;
    },
    created() {
        this._MusteriInfo();
        this._GrupListesi();

        this.IsWait = true;
    },
    components: {
    },
};
</script>